module.exports = __webpack_public_path__ + "media/images/icons/country_flags/tw-39308d8769d9190bd1aaa8ff1a6a5f88.svg";